// extracted by mini-css-extract-plugin
export default {"viewport":"style_viewport__vvug9","notification":"style_notification__mcVN9"};